var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * @desc template with cache
 */
import LRUMap from '@byted/light-render/lib/utils/LRU';
import * as lodash from './lodash';
import { isRichFormat } from '../rich';
var templateLRUCache = new LRUMap(1000);
export default function template(str, data) {
    var compiler = templateLRUCache.get(str);
    if (compiler) {
        return compiler(data);
    }
    compiler = lodash.template(str, { interpolate: /<%=([\S\s]+?)%>/g });
    templateLRUCache.set(str, compiler);
    return compiler(data);
}
export function templateRich(str, data) {
    if (isRichFormat(str)) {
        if (str.RICH_TYPE === 'jsx') {
            return str;
        }
        return __assign(__assign({}, str), { content: template(str.content, data) });
    }
    return template(str, data);
}
